import { ApplicationPermissions } from '../SubscriptionForm/SubscriptionFormContext';
import {
	HStack,
	Tab,
	TabPanel,
	TabPanels,
	Tabs,
	VStack,
} from '@montel/montelpro-shared-components-v2';
import { FunctionComponent, useEffect, useState } from 'react';
import { ApplicationPermissionTabContent } from './ApplicationPermissionTabContent';
import { ProductIcon } from 'components/common/Product/ProductIcon/ProductIcon';
import { SubscriptionBundle } from 'domain/subscription/interfaces/SubscriptionBundle';

const ApplicationPermissionTabs: FunctionComponent<{
	applicationsPermissions: ApplicationPermissions[];
	bundle?: SubscriptionBundle;
}> = ({ applicationsPermissions, bundle }) => {
	const [activeTab, setActiveTab] = useState('');

	useEffect(() => {
		if (applicationsPermissions.length > 0) {
			setActiveTab(applicationsPermissions[0].application.id);
		}
	}, [applicationsPermissions]);

	return (
		<VStack justify="center" fullWidth gap="xl">
			<HStack justify="flex-start" align="center" fullWidth>
				<Tabs activeTab={activeTab} setActiveTab={setActiveTab}>
					{applicationsPermissions.map((appPermissions) => (
						<Tab
							key={appPermissions.application.id}
							value={appPermissions.application.id}
							label={appPermissions.application.name}
							Icon={
								<ProductIcon
									productId={appPermissions.application.id}
									fontSize="sm"
									size="lg"
								/>
							}
						/>
					))}
				</Tabs>
			</HStack>
			<TabPanels currentTab={activeTab}>
				{applicationsPermissions.map((appPermissions) => (
					<TabPanel
						key={appPermissions.application.id}
						name={appPermissions.application.id}
					>
						<ApplicationPermissionTabContent
							appPermissions={appPermissions}
							inheritedPermissions={
								bundle?.productId ===
								appPermissions.application.id
									? bundle?.permissions
									: undefined
							}
						/>
					</TabPanel>
				))}
			</TabPanels>
		</VStack>
	);
};

export default ApplicationPermissionTabs;
